export const ILLUSTRATION_CATEGORIES = [
  { id: 'all', label: 'すべて' },
  { id: 'faith', label: '信仰' },
  { id: 'people', label: '人物' },
];

export const ILLUSTRATIONS = [
  {
    id: 'open-bible',
    title: '開いた聖書',
    category: 'faith',
    tags: ['聖書', '本', '礼拝', '学び'],
    accent: '#f2c94c',
    scene: 'bible',
    imageSrc: '/static/images/illust/open-bible.png',
  },
  {
    id: 'praying-person',
    title: '祈る人',
    category: 'people',
    tags: ['祈り', '人物', '教会', '相談'],
    accent: '#5bb7a8',
    scene: 'pray',
    imageSrc: '/static/images/illust/praying-person.png',
  },
  {
    id: 'small-church',
    title: '小さな教会',
    category: 'faith',
    tags: ['教会', '建物', '礼拝', '日曜日'],
    accent: '#e77d67',
    scene: 'church',
    imageSrc: '/static/images/illust/small-church.png',
  },
  {
    id: 'grape',
    title: 'ぶどう',
    category: 'faith',
    tags: ['ぶどう', '葡萄', '実り', '聖餐', 'ぶどう園', '聖書'],
    accent: '#8e5bb7',
    scene: 'grape',
    imageSrc: '/static/images/illust/grape.png',
  },
];

export function getIllustrationById(id) {
  return ILLUSTRATIONS.find((item) => item.id === id) || null;
}

export function getIllustrationCategoryLabel(categoryId) {
  return ILLUSTRATION_CATEGORIES.find((category) => category.id === categoryId)?.label || categoryId;
}

export function getAbsoluteIllustrationImage(item) {
  if (!item?.imageSrc) {
    return 'https://www.asmrchurch.com/static/images/i4.jpg';
  }

  if (item.imageSrc.startsWith('http')) {
    return item.imageSrc;
  }

  return `https://www.asmrchurch.com${item.imageSrc}`;
}
